module.exports = __webpack_public_path__ + "static/media/blur_bg.8b8a6b6f.png";